<template>
  <section>
    <div class="dropdown-menu-container">
      <!-- User Profile -->
      <router-link :to="{ name: 'UserProfile' }" class="dropdown-item-container">
        <div class="item-main">
          <img style="background: white" :src="user.picture" />
          <div class="item-txts">
            <span class="item-title" :title="user.name">{{ user.name }}</span>
            <p>{{ $t('DropdownMenu.accessProfile') }}</p>
          </div>
        </div>
      </router-link>
      <!-- Support Chat -->
      <button class="dropdown-item-container" @click.prevent="toggleSupportChat" v-if="$store.state.template.userProfile.supportChatProvider && $store.state.template.userProfile.supportChatProvider.active">
        <div class="item-main">
          <i class="fas fa-comments item-icon"></i>
          <div class="item-txts">
            <span class="item-title">{{ $t('DropdownMenu.support') }}</span>
            <p>{{ $t('DropdownMenu.talkToUs') }}</p>
          </div>
        </div>
      </button>
      <!-- User Notes -->
      <button class="dropdown-item-container" @click.prevent="openUserNotes" v-if="$store.state.template.userProfile.userNotesProvider && $store.state.template.userProfile.userNotesProvider.active">
        <div class="item-main">
          <i class="fas fa-sticky-note item-icon"></i>
          <div class="item-txts">
            <span class="item-title">{{ $t('DropdownMenu.notes') }}</span>
            <p>{{ $t('DropdownMenu.seeYourNotes') }}</p>
          </div>
        </div>
      </button>
      <!-- userGallery -->
      <router-link :to="{ name: 'UserGallery' }" class="dropdown-item-container" v-if="$store.state.template.userProfile.userGalleryProvider && $store.state.template.userProfile.userGalleryProvider.active">
        <div class="item-main">
          <i class="fas fa-images item-icon"></i>
          <div class="item-txts">
            <span class="item-title">{{ $t('DropdownMenu.gallery') }}</span>
            <p>{{ $t('DropdownMenu.seeYourGallery') }}</p>
          </div>
        </div>
      </router-link>
      <!-- QRCode -->
      <router-link :to="{ name: 'QRCodeView' }" class="dropdown-item-container" v-if="$store.state.template.userProfile.userQRCodeProvider && $store.state.template.userProfile.userQRCodeProvider.active">
        <div class="item-main">
          <i class="fas fa-qrcode item-icon"></i>
          <div class="item-txts">
            <span class="item-title">{{ $t('DropdownMenu.qrCode') }}</span>
            <p>{{ $t('DropdownMenu.seeYourQRCode') }}</p>
          </div>
        </div>
      </router-link>
      <!-- PersonalSchedule -->
      <router-link :to="{ name: 'PersonalSchedule' }" class="dropdown-item-container" v-if="$store.state.template.userProfile.personalScheduleProvider.active">
        <div class="item-main">
          <i class="fas fa-calendar-alt item-icon"></i>
          <div class="item-txts">
            <span class="item-title">{{ $t('DropdownMenu.personalSchedule') }}</span>
            <p>{{ $t('DropdownMenu.seeYourEvents') }}</p>
          </div>
        </div>
      </router-link>
      <!-- Contacts -->
      <router-link :to="{ name: 'Contacts' }" class="dropdown-item-container" v-if="$store.state.template.userProfile.contactsProvider.active">
        <div class="item-main">
          <i class="fas fa-user-friends item-icon"></i>
          <div class="item-txts">
            <span class="item-title">{{ $t('DropdownMenu.contacts') }}</span>
            <p>{{ $t('DropdownMenu.seeYourContacts') }}</p>
          </div>
        </div>
      </router-link>
      <!-- Cart -->
      <router-link :to="{ name: 'Cart' }" class="dropdown-item-container" v-if="$store.state.template.userProfile.cartProvider.active">
        <div class="item-main">
          <i class="fas fas fa-star item-icon"></i>
          <div class="item-txts">
            <span class="item-title">{{ $t('DropdownMenu.favorites') }}</span>
            <p>{{ $t('DropdownMenu.accessMaterials') }}</p>
          </div>
        </div>
      </router-link>
      <!-- Certificates -->
      <router-link :to="{ name: 'Certificates' }" class="dropdown-item-container" v-if="$store.state.template.userProfile.certificatesProvider.active">
        <div class="item-main">
          <i class="fas fa-landmark item-icon"></i>
          <div class="item-txts">
            <span class="item-title">{{ $t('DropdownMenu.certificates') }}</span>
            <p>{{ $t('DropdownMenu.seeYourCertificates') }}</p>
          </div>
        </div>
      </router-link>
      <!-- Logout -->
      <div class="dropdown-item-container" @click.prevent="logout">
        <div class="item-main">
          <i class="fas fa-sign-out-alt item-icon"></i>
          <div class="item-txts">
            <span class="item-title">{{ $t('DropdownMenu.logout') }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DropdownMenu',

  props: {
    user: Object,
    nextActivityRoute: Object,
  },

  methods: {
    openUserNotes() {
      this.$root.$emit('openUserNotes');
      // pass the focus to the notes
      setTimeout(() => {
        document.querySelector('.notes-container').focus();
      }, 100);
    },
    logout() {
      this.$store.commit('resetUser');
      if (this.$store.state.template.useUnifiedLoginRegister) {
        this.$router.push({ name: 'Home' });
      } else {
        this.$router.push({ name: 'Login' });
      }
    },
    toggleSupportChat() {
      this.$root.$emit('toggleSupportChat');
    },
  },
};
</script>

<style lang="scss">
.dropdown-menu-container {
  border: 1px solid #88888840;
  box-shadow: 0px 4px 10px #88888820;
  background: var(--login-bgColor);
  border-radius: var(--input-borderRadius);
  max-height: calc(100dvh - 60px);
  overflow-y: auto;

  @include media('<=tablet') {
    background: var(--login-bgColor);
  }
}
.dropdown-item-container {
  position: relative;
  min-width: 240px;
  padding: 0;
  border: none;
  border-bottom: 1px solid #88888860;
  background: var(--login-bgColor);
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;

  &:first-child {
    border-top-left-radius: var(--input-borderRadius);
    border-top-right-radius: var(--input-borderRadius);
  }

  &:last-child {
    border-bottom: none;
    height: 50px;
    border-bottom-left-radius: var(--input-borderRadius);
    border-bottom-right-radius: var(--input-borderRadius);
  }
  &:active {
    transform: scale(0.97);
  }
}
.item-main {
  position: relative;
  color: var(--header-profileColor);
  height: 100%;

  display: flex;
  align-items: center;

  img,
  i {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin: 15px;
    float: left;
    object-fit: cover;
  }
  .item-icon {
    display: flex;
    width: 40px;
    align-items: center;
    justify-content: center;
  }
  .item-txts {
    position: relative;
    display: flex;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .item-title {
      max-width: 160px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 1rem;
    }
    p {
      font-size: 0.7rem;
      opacity: 0.7;
    }
  }
}
.next-live-activity {
  position: relative;
  width: 100%;
  padding: 8px 14px;
  margin-bottom: -4px;
  font-size: 1rem;
  background: var(--hover-bgColor);
  transition: all 70ms ease-in-out;

  display: flex;
  align-items: center;

  &:hover {
    transform: scale(1.06);
  }

  button {
    position: relative;
    margin-left: auto;
    padding: 6px;
    font-size: 0.7rem;
    color: var(--header-profileColor);
    background: transparent;
    border: 1px solid var(--header-profileColor);
  }
}
</style>
